import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../authConfig"; // Your MSAL configuration file

//using instead of msal/react for edge case when account info is needed outside of a jsx component
export async function GetUserEmail() {
  try {
    const msal = new PublicClientApplication(msalConfig);
    await msal.initialize();
    const accounts = msal.getAllAccounts();
    return accounts[0].idTokenClaims?.["extension_UserEmail"];
  } catch (_error) {
    return "";
  }
}

export function formatDate(date: string) {
  const d = new Date(date);
  return `${d.toLocaleDateString("en-CA")} ${d.toLocaleString("en-CA", { timeStyle: "medium", hour12: false })}`;
}

export const formatBits = (bytes: number): string => {
  switch (true) {
    case bytes >= 1024 * 1024:
      return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;

    case bytes >= 1024:
      return `${(bytes / 1024).toFixed(2)} KB`;

    default:
      return `${bytes.toFixed(2)} Bytes`;
  }
};

export interface filterOption {
  primaryOption?: string;
  secondaryOption?: string;
}

export function getFilterOptions(options1: any, options2: any, filterOut: filterOption[] = []) {
  options1 = options1.filter((x: any) => !filterOut.some((y) => y.primaryOption === x.value && y.secondaryOption == null));
  const combinedOptions: { label: string; value: string }[] = options1.flatMap((opt1: any) => {
    let children = options2[opt1.value] || [];
    children = children.filter(
      (x: any) => !filterOut.some((y) => y.secondaryOption === x.value && (y.primaryOption == null || y.primaryOption === opt1.value))
    );
    return children.map((child: any) => ({
      label: `${opt1.label} - ${child.label}`,
      value: `${opt1.value} - ${child.value}`,
    }));
  });
  return combinedOptions;
}

export function getTableBuilderFilterOptions(options1: any, options2: any, filterOut: filterOption[] = []) {
  options1 = options1.filter((x: any) => !filterOut.some((y) => y.primaryOption === x.value && y.secondaryOption == null));
  const combinedOptions: string[] = options1.flatMap((opt1: any) => {
    let children = options2[opt1.value] || [];
    children = children.filter(
      (x: any) => !filterOut.some((y) => y.secondaryOption === x.value && (y.primaryOption == null || y.primaryOption === opt1.value))
    );
    return children.map((child: any) => `${opt1.label} - ${child.label}`);
  });
  return combinedOptions;
}
